import { render, staticRenderFns } from "./VesselRecordShipBuilderPieChart.vue?vue&type=template&id=a374cdee&scoped=true&"
import script from "./VesselRecordShipBuilderPieChart.vue?vue&type=script&lang=js&"
export * from "./VesselRecordShipBuilderPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a374cdee",
  null
  
)

export default component.exports